
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import { ApiModel } from '../models/Product';

@Component({})
export default class ProductListBehaviourMixin extends Vue {
  @Prop() public products!: ApiModel[];
  @Prop() public activeIndex!: number;

  public isActive(index: number): boolean {
    return this.activeIndex === index;
  }
  // noinspection JSUnusedLocalSymbols
  public select(pk: string): void {
    const currentIndex = this.activeIndex;
    const newIndex = this.products.findIndex(e => e.pk === pk);
    this.$emit('product-selected', pk, currentIndex, newIndex);
  }
}
